module.exports = __webpack_public_path__ + "assets/img/thumb_ch4_news-item-1.1372143e.jpg";